<template>
    <div class="vacancy-filter" v-if="vacancyPage != null">
        <div class="vacancy-filter-city">
            <ul>
                <li><a href="" @click.prevent="filterByCity('almaty')" :class="{active : cityActive === 'almaty'}">Алматы</a></li>
                <li><a href="" @click.prevent="filterByCity('astana')" :class="{active : cityActive === 'astana'}">Астана</a></li>
                <li><a href="" @click.prevent="filterByCity('regions')" :class="{active : cityActive === 'regions'}">Регионы</a></li>
                <!-- <li v-for="(item, index) in cityFilter" :key="index">
                    <a href="#" @click.prevent="filterByCity(item)" :class="{active : cityActive === item}">{{cityFilterNames[index]}}</a>
                </li> -->
            </ul>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        name: 'vacancy-filter',
        components: {
        },
        data () {
            return {
                routerName: this.$router.history.current.name,
                cityFilterNames: [],
                cityFilter: [],
                themeFilter: [],
                cityActive: null,
                themeActive: null,
                initFilter: false,
                filterArr: [],
                saleStat: 0,
            }
        },
        computed: mapGetters({
            setup: 'loadPageSetUp',
            vacancyPage: 'loadVacancyPage',
        }),
        methods: {
            // buildFiterCity() {
            //     if (this.vacancyPage != null) {
            //         this.cityFilter = [];
                    
            //         var data = this.vacancyPage.cards;
            //         var i;
            //         var n;
            //         // console.log(data, 'test')
            //         for (i = 0; i < data.length; i++) {
            //             this.cityFilter.push(data[i].city.slug);
            //             this.cityFilterNames.push(data[i].city.name);
            //         }
                    
            //         this.cityFilter = this.uniqueElementsInArray(this.cityFilter);
            //         this.cityFilterNames = this.uniqueElementsInArray(this.cityFilterNames);
            //     }
            //     // console.log(this.cityFilter, this.cityFilterNames, 'cityyyy')

            //     // console.log(this.cityFilter, this.themeFilter);
            // },
            // uniqueElementsInArray(arr) {
            //     let result = [];
            //     for (let str of arr) {
            //         if (!result.includes(str)) {
            //             result.push(str);
            //         }
            //     }
            //     return result;
            // },
            filterByCity(city) {
                this.cityActive = city;
                this.initFilter = true;

                
                // var data = this.vacancyPage.cards;
                var dataContacts = this.vacancyPage.hr_info;

                console.log(city, dataContacts)

                
                // var filteredItems = data.filter(item => {
                //     return item.city.slug == city
                // });
                var filterContacts = dataContacts.filter(item => {
                    return item.city.slug == city
                });

                if (city == 'almaty') {
                    this.$store.commit('filterVacancyItems', this.vacancyPage.vac_almaty);
                    this.$store.commit('filterVacancyContacts', filterContacts);
                } else if (city == 'astana') {
                    this.$store.commit('filterVacancyItems', this.vacancyPage.vac_nursultan);
                    this.$store.commit('filterVacancyContacts', filterContacts);
                } else {
                    this.$store.commit('filterVacancyItems', this.vacancyPage.vac_regions);
                    this.$store.commit('filterVacancyContacts', this.vacancyPage.hr_info_regions);
                }
                
                this.animateCards();
            },
            animateCards() {
                this.$store.commit('cardAnimateSet', false);
                setTimeout(()=>{
                    this.$store.commit('cardAnimateSet', true);
                },50);
            },
            initFilterCityByPageLoad() {
                if (this.vacancyPage != null) {
                    this.filterByCity('almaty');
                }
            },
            // startLoader() {
            //     if (this.routerName == 'home') {
            //         this.$parent.$parent.$parent.$refs.topProgress.start();
            //     } else {
            //         this.$parent.$parent.$refs.topProgress.start();
            //     }
            // }
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
            // this.buildFiterCity();
            this.initFilterCityByPageLoad();
            this.$store.watch(
                (state) => state.projectItemsFilter,
                (newValue) => {
                    // this.buildFiterCity();
                    this.initFilterCityByPageLoad();
                }
            )
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/vacancy-page/vacancy-filter.scss';
    @import '@/styles/components/vacancy-page/respond/vacancy-filter-respond.scss';
    // @import '@/styles/respond/vacancy/vacancy-filter-respond.scss';
</style>